import http from './http';

// 外设管理列表
export const fetchPeripheralManagementList = (data) => {
  return http({
    url: '/shop/peripheral/manage/list',
    method: 'POST',
    data,
  });
};

// 外设类目列表
export const queryPeripheralCategoryAll = () => {
  return http({
    url: '/shop/peripheral/category/List',
    method: 'GET',
  });
};

// 上下架修改
export const peripheralBatchOnOrOff = (data) => {
  return http({
    url: '/shop/peripheral/batch/include/flag',
    method: 'POST',
    data,
  });
};

// 外设引入列表
export const peripheralIntroList = (data) => {
  return http({
    url: '/shop/peripheral/spu/list',
    method: 'POST',
    data,
  });
};

// 门店外设编辑
export const updatePeripheralInfo = (data) => {
  return http({
    url: '/shop/peripheral/edit',
    method: 'POST',
    data,
  });
};

// 外设售卖列表
export const queryPeripheralSaleList = (data) => {
  return http({
    url: '/shop/peripheral/sale/list',
    method: 'POST',
    data,
  });
};

// 外设-门店库存
export const fetchShopPeripheralList = (data) => {
  return http({
    url: '/peripheral/inventory/shop',
    method: 'POST',
    data,
  });
};

// 外设-查询sku对应的房间库存
export const fetchPeripheralStockDetail = (data) => {
  return http({
    url: '/peripheral/inventory/sku',
    method: 'POST',
    data,
  });
};

// 外设-调整外设柜库存
export const adjustPeripheralStock = (data) => {
  return http({
    url: '/peripheral/inventory/set',
    method: 'POST',
    data,
  });
};

// 外设租借-预下单
export const preOrder = (data) => {
  return http({
    url: '/peripherals/order',
    method: 'POST',
    data,
  });
};

// 外设-订单查询
export const getOrderDetail = (orderNo: string) => {
  return http({
    url: `/peripherals/order`,
    method: 'GET',
    params: { orderNo },
  });
};

// 外设-订单改价
export const orderChangePrice = (data: { orderNo: string; totalActualPrice: number }) => {
  return http({
    url: '/peripherals/order/change-price',
    method: 'POST',
    data,
  });
};

// 外设-入账房间不支付
export const orderBillNotPay = (data) => {
  return http({
    url: '/peripherals/order/bill',
    method: 'POST',
    data,
  });
};

// 外设-支付入账
export const orderBillPay = (data: {
  orderNo: string;
  payPrice: number;
  payType?: number;
  remark?: string;
  fkdFlag: boolean;
  operationPage?: string;
}) => {
  return http({
    url: '/peripherals/order/pay/bill',
    method: 'POST',
    data,
  });
};

// 外设-获取预定单下外设库存列表
export const getPeripheralListByResvNo = (data) => {
  return http({
    url: '/peripheral/inventory/listSkuByResvNo',
    method: 'POST',
    data,
  });
};

// 外设-归还-批量
export const batchReturnPeripheral = (data) => {
  return http({
    url: '/peripheral/inventory/returnBatch',
    method: 'POST',
    data,
  });
};

// 外设-门店房间库存列表
export const getPeripheralListByRoomId = (data) => {
  return http({
    url: '/peripheral/inventory/listSkuByRoom',
    method: 'POST',
    data,
  });
};
